// extracted by mini-css-extract-plugin
export default {"main":"Main_main__peD8L","light":"Main_light__b2Lp9","dark":"Main_dark__9OgYz"};